import FullPageStore from "./FullPageStore"
import LoadStore from "./LoadStore"
import UserAgentStore from "./UserAgentStore"

export default {
  UserAgentStore: UserAgentStore,
  LoadStore: LoadStore,
  FullPageStore: FullPageStore,
}
